import React from 'react';
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Div from "@jumbo/shared/Div";
import DatePicker from "../../../shared/DatePicker";
import { getAPIData, getAPIDataParams, postApi } from '../../../utils/apiFunction';
import { adalApiFetch, userInfo } from '../../../../adalConfig';
import useSwalWrapper from "@jumbo/vendors/sweetalert2/hooks";
import { ACCESS, ACCESS_SECTIONS } from '../../../utils/constants/access';
import { checkAccess } from '../../../utils/roleFunctions';
import { CircularProgress } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import SubmitButtonDisplayer from "../../../components/SubmitButtonDisplayer";
import OysterOrder from "../../../components/OysterOrder";
import { delIcon } from "../../../themes/myStyles";
import { textfieldDateFormat, startOfDay, tomorrow } from "../../../utils/dateFunctions";
import StaffMember from "../../../components/StaffMember";
import ControlledTextField from "../../../components/ControlledTextField";
import CropYearSelect from "../../../components/CropYearSelect";
import SelectTextField from "../../../components/SelectTextField";
import SalesOrderSelect from "../../../components/SalesOrderSelect";
import { GetAllCacheData, addToCache } from "../../../utils/cacheFunctions";
import { salesOrderTypes, SOstatusList } from '../../../utils/constants/selectFields';
import StringSelect from "../../../components/StringSelect";
import IconButton from '@mui/material/IconButton';
import Button from '@mui/material/Button';
import SOPreview from "../Tables/SOPreview";

const AddCreditMemo = (props) => {
    const uri = process.env.REACT_APP_BASE_URL;
    const [user, setUser] = React.useState(userInfo());
    const [completed, setCompleted] = React.useState(props.completed);
    const [myobid, setMyobid] = React.useState(null);
    const [description, setDescription] = React.useState(null);
    const [lotNbr, setLotNbr] = React.useState(null);
    const [isused, setIsused] = React.useState(true);
    const [loading, setLoading] = React.useState(false);
    const [search, setSearch] = React.useState(null);
    const [searching, setSearching] = React.useState(false);
    const [soReloadKey, setSoReloadKey] = React.useState(0);
    const [soPreviewReloadKey, setSoPreviewReloadKey] = React.useState(0);
    const id = props.data ? props.data.id : '';
    const Swal = useSwalWrapper();
    const requiredEditAccess = { key: ACCESS_SECTIONS.SALES, value: ACCESS.EDIT };
    const requiredSalesOrderEditAccess = { key: ACCESS_SECTIONS.SALESORDEREDIT, value: ACCESS.EDIT };
    const [returnData, setReturnData] = React.useState(null);
    const [soPreviewId, setSoPreviewId] = React.useState('');
    
    React.useEffect(() => {
        const checkArr = (data) => {
            var retData = data;
            if (Array.isArray(data)) {
                retData = data[0];
            }
            setReturnData(retData);
        }
    }, [])
    const numToBool = (numArr) => {
        var boolArr = []
        for (var i = 0; i < 7; i++) {
            if (numArr.find((n) => n === i)) {
                boolArr.push(true);
            } else {
                boolArr.push(false);
            }
        }
        console.log(boolArr);
        return boolArr;
    }

    React.useEffect(() => {
        if (returnData) {
            setMyobid(returnData.myobid);
            setDescription(returnData.description);
            setIsused(returnData.isUsed);
        }
    }, [returnData])

    const validate = () => {
        var warningMessages = [];
        var errorMessages = [];

        if (!myobid || myobid === '') {
            errorMessages.push("You must select a Sales Order");
        }

        if (!description || description === '') {
            errorMessages.push("You must enter a Description");
        }

        const formatErrorMessage = (array) => {
            var errString = '';
            array.map((a) => {
                errString = errString + a + '<br/>';
            });
            return errString;
        }
        if (errorMessages.length > 0) {
            Swal.fire({
                html: formatErrorMessage(errorMessages),
                icon: 'error',
                title: 'Oops...',
            });
        } else if (warningMessages.length > 0) {
            Swal.fire({
                html: formatErrorMessage(warningMessages),
                icon: 'warning',
                title: 'Oops...',
                showCancelButton: true,
                confirmButtonText: 'Yes, Continue',
                cancelButtonText: 'No, I\'ll edit it',
            }).then(result => {
                if (result.value) {
                    submit();
                }
            });
        } else {
            submit();
        }
    }

    const submit = async () => {
        setLoading(true);
        setCompleted(true);
        var data = {
            User: user?.name,
            SalesOrderId: myobid.id ? myobid.id : null,
            CustomerId: myobid.customerId ? myobid.customerId : null,
            Status: 'Select Stock',
            IsReused: isused ? isused : false,
            Description: description ? description : '',
        }
        console.log(data, id);

        await adalApiFetch(fetch, uri + '/CreditMemo/AddUpdate/0?' + new URLSearchParams({
            ...data
        }), {
            method: 'post',
        });

        setLoading(false);
        if (props.reload) {
            console.log(props.reload)
            props.reload();
        }
    }

    const doSearch = async (str) => {
        setLotNbr(str);
        console.log(str);
        setSoReloadKey(k => k + 1); 
    }


    // Event: called when a Sales Order is selected
    const handleSalesOrderSelected = React.useCallback((so) => {
        console.log('Sales Order selected in Add Credit Memo: ', so?.id);
        setSoPreviewId(so?.id ?? '');
        setSoPreviewReloadKey(k => k + 1); // force SOPreview to remount/reload
    }, []);

    return (
        <Box
            component="form"
            noValidate
            autoComplete="off"
        >
            <Div>

                <Grid container spacing={0} mb={1}>
                    <React.Fragment>
                        <Grid container spacing={3} direction="column">
                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                <ControlledTextField label="Search" state={search} setState={setSearch} />&nbsp;
                                {!searching && (
                                    <Button onClick={() => { doSearch(search) }}>
                                        Search
                                    </Button>
                                )}
                                {searching && (
                                    <CircularProgress size={20} />
                                )}
                            </Grid>
                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                {/* Force reload of SalesOrderSelect when LotNbr changes by using key */}
                                <SalesOrderSelect
                                    key={`${lotNbr || 'no-lot'}-${soReloadKey}`}
                                    myobid={(returnData ? returnData.myobid : null)}
                                    lotSerialNbr={lotNbr}
                                    state={myobid}
                                    setState={setMyobid}
                                    setSearching={setSearching}
                                    disabled={props.edit || completed}
                                    onSelected={handleSalesOrderSelected}
                                />
                            </Grid>
                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                <TextField
                                    disabled={completed}
                                    id="outlined-multiline-static"
                                    label="Description"
                                    value={description}
                                    onChange={(event) => { setDescription(event.target.value) }}
                                    multiline
                                    InputLabelProps={{ shrink: true }}
                                    rows={3} />
                            </Grid>

                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                <FormControlLabel
                                    style={{ paddingLeft: '9px' }}
                                    control={<Checkbox style={{ paddingLeft: '0px', paddingRight: '0px' }} defaultChecked='true' onChange={(event) => { setIsused(event.target.checked); }} />}
                                    label="Reuse Stock"
                                    disabled={completed}
                                    labelPlacement="end"
                                />
                            </Grid>
                            <Grid item xs={6} sm={6} md={6} lg={6} xl={6}>
                                <SOPreview key={soPreviewReloadKey} id={soPreviewId} />
                                
                            </Grid>
                        </Grid>

                    </React.Fragment>
                </Grid>

                <SubmitButtonDisplayer completed={completed} loading={loading} allowed={checkAccess(props.access, requiredEditAccess) || checkAccess(props.access, requiredSalesOrderEditAccess)} submitFunc={validate} handleClose={props.handleClose} />

            </Div>
        </Box >
    );
};

export default AddCreditMemo;
